import React, { useState, useCallback } from "react";
import MarketList from "./MarketList";
import "./MarketPage.css";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const MarketPage = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = useCallback((e) => {
    setSearchQuery(e.target.value);
  }, []);

  const handleSearchSubmit = useCallback(
    (e) => {
      e.preventDefault();
      // Handle search submission if needed
      console.log("Search submitted:", searchQuery);
    },
    [searchQuery]
  );

  return (
    <div
      className="market-page !px-0"
      style={{
        background:
          "radial-gradient(51.47% 93.67% at 92.92% 27.08%, #161837 0%, #161837 72.6%)",
      }}
    >
     
      {/* Page Header */}
      <div className="px-4 sm:px-6 lg:px-8 ">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between space-y-4 lg:space-y-0">
          {/* Title Section */}
          <div className="flex-1">
            <h1 className="page-title !mt-16 text-xl sm:text-2xl lg:text-3xl font-bold text-white">
              Top Tokens by Market Capitalization
            </h1>
          </div>

          {/* Search Section */}
          <div className="w-full lg:w-auto !mt-16 ">
            <form onSubmit={handleSearchSubmit} className="search-form">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search markets..."
                  className="w-full lg:w-80 px-4 py-2 bg-gray-700  text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-white">
                  <MagnifyingGlassIcon className="w-4 h-4" />
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Market Content */}
      <section className="p-8 ">
        <div className="p-5">
          <MarketList searchQuery={searchQuery} />
        </div>
      </section>
    </div>
  );
};

export default MarketPage;
